module.exports = __webpack_public_path__ + "img/s5-1.d75d9c1c.jpg";